export function SelectForm(options: {
    url: string,
    label: string,
    placeholder?: string,
    title?: string,
    searchKeyColumn?: string,
    searchQueryColumn?: string,
    searchDisplayColumn?: string
}) {
    return {
        groups: [ {
            sections: [ {
                rows: [ {
                    elements: [ {
                        id: 'model',
                        type: 'select',
                        name: 'model',
                        label: options.label,
                        validation: {},
                        config: {
                            url: options.url,
                            relation: true,
                            searchKeyColumn: options.searchKeyColumn || 'id',
                            searchQueryColumn: options.searchQueryColumn || 'name',
                            searchDisplayColumn: options.searchDisplayColumn || 'name',
                        },
                        attributes: {
                            placeholder: options.placeholder || options.label,
                            title: options.title || options.label
                        }
                    } ]
                } ]
            } ]
        } ]
    };
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/select-form.ts